import './subMenu.scss';
import React, { useCallback, useEffect, useState } from 'react';
import BannerSecondary from 'components/features/home/bannerSecondary/BannerSecondary';
import { subMenuIndexState, updateSubMenuIndex } from 'redux/slices/subMenuSlices';
import IconPromise from 'components/widgets/IconPromise/IconPromise';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import { routesState } from 'redux/slices/routesSlice';
import { useTranslate, useLanguage } from 'context/languageContext';
import UseSEO from 'hooks/useSEO/UseSEO';
import CrumbTrail from 'components/features/crumbTrail/CrumbTrail';
// import SubMenuSkeleton from './subMenuSkeleton/SubMenuSkeleton';

interface ISubMenu {
  vertical?: boolean;
  noRoutesView?: boolean;
}

function SubMenu({ vertical, noRoutesView }: ISubMenu) {
  const [searchParams] = useSearchParams();
  const currentLanguage = useLanguage();
  const location = useLocation();
  const dispatch = useDispatch();
  const t = useTranslate();
  const BASE_LOCATION = `/${location.pathname.slice(4).split('/')[0]}`;
  const FULL_LOCATION = `/${location.pathname.slice(4)}`;
  const SUB_LOCATION = location.pathname.slice(4).split('/');
  const PATH_DEPTH = location.pathname.slice(4).split('/').filter((el) => el)?.length;
  const PAGE_ID = searchParams.get('pageId');
  const routesSelector = useSelector(routesState);
  const subMenuIndexSelector = useSelector(subMenuIndexState);
  const [menuIndex, setMenuIndex] = useState<any>(null);
  const [selectedChild, setSelectedChild] = useState<any>(null);
  // const [loading, setLoading] = useState<any>(true);
  const [options, setOptions] = useState<any>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [generateUrl, generateTitleAndMeta, navigateStaticPage] = UseSEO();
  const navigate = useNavigate();

  const exception = SUB_LOCATION.join('/').includes(RUTAS_GENERALES_MUL2.atclientComplaintsSuggestions[currentLanguage]);
  const sliceValue = exception ? 1 : 2; //excepcion
  const formatSubLocation = SUB_LOCATION.filter((el, i) => (el.length > 0) && i <= sliceValue);
  const currentUrl = `/${formatSubLocation.join('/')}`;

  const handleClick = useCallback(async (selected) => {
    const selectedOpt = selected ? selected : options[0];
    try {
      if(selectedChild) {
        const parentPath = routesSelector.find((route) => route.child.some((c) => c.pageId === selectedOpt.pageId && c.name === selectedOpt.name));
        if (parentPath) {
          navigate(generateUrl(`${parentPath.url}?pageId=${selectedChild.pagePublicCode || selectedChild.pageId}`, 'SUB'), { state: { pageId: selectedOpt.pageId } });
        }
        setSelectedChild(null);
      }
      else if (selectedOpt) {
        if (selectedOpt?.url) {
          const excep = SUB_LOCATION.join('/').includes(RUTAS_GENERALES_MUL2.atclientComplaints[currentLanguage]);
          const url = PATH_DEPTH === 1
            ? selectedOpt?.url
            : ((menuIndex >= 0 && !excep) ? selectedOpt?.url : FULL_LOCATION);
          (url.includes('https://') || url.includes('http://'))
            ? window.location.assign(url)
            : navigate(generateUrl(url, 'SUB'));
        } else {
          const parentPath = routesSelector.find((route) => route.child.some((c) => c.pageId === selectedOpt.pageId && c.name === selectedOpt.name));
          if (parentPath) {
            const codePublic = await navigateStaticPage(selectedOpt.pageId, true, parentPath.url);
            navigate(generateUrl(`${parentPath.url}?pageId=${codePublic || selectedOpt.pagePublicCode || selectedOpt.pageId}`, 'SUB'), { state: { pageId: selectedOpt.pageId } });
          }
        }
      }
    } catch (error) {
      navigate(RUTAS_GENERALES_MUL2.error);
      return error;
    }
  }, [options, menuIndex, currentLanguage, routesSelector, navigate, generateUrl, navigateStaticPage, selectedChild]);

  const concatRoutes = useCallback(() => {
    try {
      const exception1 = SUB_LOCATION.join('/').includes(RUTAS_GENERALES_MUL2.atclientComplaints[currentLanguage]);
      const exception2 = SUB_LOCATION.join('/').includes(RUTAS_GENERALES_MUL2.atclientInquiry[currentLanguage]);
      // const HOME = { name: t('lb_seo_title_inicio'), url: '/' };
      const EXCEPTION_ROUTE = {
        name: exception1 ? t('lb_reclamaciones') : t('lb_consultas'),
        url: exception1
          ? `/${RUTAS_GENERALES_MUL2.atclientComplaints[currentLanguage]}`
          : `/${RUTAS_GENERALES_MUL2.atclientInquiry[currentLanguage]}`
      };

      const currentRoutes: any = [];
      const subMenuItems = routesSelector.find((route) => route.url === BASE_LOCATION);

      /* Camino de migajas */
      if (subMenuItems?.child?.length) {
        const myPageId = subMenuItems?.child[0].pagePublicCode
          ? subMenuItems?.child[0]?.pagePublicCode
          : subMenuItems?.child[0]?.pageId;

        if (PAGE_ID) {
          currentRoutes.push({
            name: subMenuItems?.name,
            url: subMenuItems?.child[0].url
              ? subMenuItems?.child[0].url
              : `${subMenuItems?.url}?pageId=${myPageId}`,
            onClick: () => dispatch(updateSubMenuIndex(0))
          });
        } else {
          currentRoutes.push({
            name: subMenuItems?.name,
            url: subMenuItems?.child[0].url
              ? subMenuItems?.child[0].url
              : subMenuItems?.url,
            onClick: () => dispatch(updateSubMenuIndex(0))
          });
        }
      } else {
        currentRoutes.push({ name: subMenuItems?.name, url: subMenuItems?.url });
      }

      if (PAGE_ID) {
        const myPageId = subMenuItems?.child[menuIndex]?.pagePublicCode
          ? subMenuItems?.child[menuIndex].pagePublicCode
          : subMenuItems?.child[menuIndex]?.pageId;

        currentRoutes.push({
          name: subMenuItems?.child[menuIndex]?.name,
          url: `${subMenuItems?.url}?pageId=${myPageId}`
        });
      } else {
        if (subMenuItems?.child[menuIndex]) {
          currentRoutes.push({
            name: subMenuItems?.child[menuIndex]?.name,
            url: subMenuItems?.child[menuIndex]?.url
          });
        }
      }

      const ROUTES = (exception1 || exception2)
        ? [...currentRoutes, EXCEPTION_ROUTE]
        : [...currentRoutes];

      return ROUTES;
    } catch (error) {
      return error;
    }
  }, [SUB_LOCATION, RUTAS_GENERALES_MUL2, currentLanguage, routesSelector, BASE_LOCATION, PAGE_ID, menuIndex]);



  const init = async () => {
    try {
      let index: any = null;
      let selected: any = null;
      // setLoading(true);

      if (routesSelector?.length > 0) {
        const subMenuItems = routesSelector.find((route) => (route.url === BASE_LOCATION && (route.child.some((c) =>  (PAGE_ID && String(c.pagePublicCode) === String(PAGE_ID))|| (PAGE_ID && Number(c.pageId) === Number(PAGE_ID)) || c.url === BASE_LOCATION))) || (route.url === BASE_LOCATION));
        if (subMenuItems) {
          setOptions(subMenuItems.child);
          if(subMenuItems.child?.length > 0) {
            index = subMenuItems.child.findIndex((opt) =>
              (PAGE_ID && Number(opt.pageId) === Number(PAGE_ID)) ||
              (PAGE_ID && String(opt.pagePublicCode) === String(PAGE_ID)) ||
              (opt.child.some((c) => (PAGE_ID && (Number(c.pageId) === Number(PAGE_ID))) || (PAGE_ID && (String(c.pagePublicCode) === String(PAGE_ID))) || (c.url === currentUrl) )) ||
              opt.url === currentUrl ||
              opt.url === currentUrl.slice(0, -1)
            );

            selected = subMenuItems?.child[index]?.child?.find((c) =>
                          (PAGE_ID && (Number(c.pageId) === Number(PAGE_ID))) ||
                          (PAGE_ID && (String(c.pagePublicCode) === String(PAGE_ID)))
                          || (c.url === currentUrl)
                        );

            setSelectedChild(selected);
            index > 0 ? dispatch(updateSubMenuIndex(index)): dispatch(updateSubMenuIndex(0));
          }
        }//OBTENIENDO EL SUBMENÜ SELECCIONADO
        else setOptions([]); //reiniciamos las opciones entre páginas
      }
    }
    catch (error) { return error; }
    // finally { setLoading(false); }
  };

  /* EFECTOS */
  useEffect(() => {
    init();
  }, [currentLanguage, routesSelector, FULL_LOCATION]);

  useEffect(()=>{
    setMenuIndex(subMenuIndexSelector);
  },[subMenuIndexSelector]);

  useEffect(() => {
    if (menuIndex !== null && options[menuIndex]) handleClick(selectedChild || options[menuIndex]);
  }, [menuIndex]);
  /* FIN EFECTOS */

  return (
    /* loading
      ? <SubMenuSkeleton />
      : */ options.length > 0 ? (
        <div className='sub-menu-container'>
          <div className='container'>
            {!noRoutesView && (
              <div className='sub-menu-routes-urls col-12' >
                <CrumbTrail items={concatRoutes()} />
              </div>
            )}
            {options[menuIndex]?.name && (
              <div className='sub-menu-title col-12'>
                {options[menuIndex]?.iconId && <IconPromise idIcon={options[menuIndex]?.iconId} />}
                <h1>{options[menuIndex]?.name}</h1>
              </div>
            )}

            {/* CARDS */}
            <div className='sub-menu col-12'>
              <div className={`${options?.length === 5 ? 'container-5' : 'container'}`}>
                {options.map((item, i) => (
                  <BannerSecondary
                    key={item.name + i}
                    title={item.name}
                    iconId={item.iconId}
                    selected={menuIndex === i}
                    numberOfItems={options?.length}
                    onClick={() => subMenuIndexSelector === i ? handleClick(selectedChild || options[menuIndex]) : dispatch(updateSubMenuIndex(i))}
                    disabled={(!item.url && !item.pageId && !item.pagePublicCode)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : <></>
  );
}

export default React.memo(SubMenu);
